export default class Month {
  constructor(date?: Date) {
    if (date) {
      this.month = date.getMonth() + 1;
      this.year = date.getFullYear();
    }
  }

  month: number;
  year: number;

  get from() {
    return new Date(this.year, this.month - 1, 1);
  }

  get to() {
    return new Date(this.year, this.month, 0);
  }

  get name() {
    return `${this.year}-${this.month.toString().padStart(2, "0")}`;
  }
}
